/**
 * Returns a random number between min (inclusive) and max (exclusive)
 */
export function getRandomArbitrary(min: number, max: number): number {
  return Math.random() * (max - min) + min;
}

/**
 * Returns a random integer between min (inclusive) and max (inclusive)
 * Using Math.round() will give you a non-uniform distribution!
 */
export function getRandomInt(min: number, max: number): number {
  return Math.floor(Math.random() * (max - min + 1)) + min;
}

export function isOdd(n: number): boolean {
  return Math.abs(n % 2) == 1;
}

export function isEven(n: number): boolean {
  return n % 2 == 0;
}


// WEBPACK FOOTER //
// /Users/ek1z/dev/flowfestival-com/src/utils/numberUtils.ts